import { render, staticRenderFns } from "./ImportMaterialDialog.vue?vue&type=template&id=1d16f165&scoped=true"
import script from "./ImportMaterialDialog.vue?vue&type=script&lang=js"
export * from "./ImportMaterialDialog.vue?vue&type=script&lang=js"
import style0 from "./ImportMaterialDialog.vue?vue&type=style&index=0&id=1d16f165&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d16f165",
  null
  
)

export default component.exports